import { render } from "./HasManyThroughField.vue?vue&type=template&id=05d9685e"
import script from "./HasManyThroughField.vue?vue&type=script&lang=js"
export * from "./HasManyThroughField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasManyThroughField.vue"]])

export default __exports__